import useForm from '../../../hooks/useForm';
import { Box, Button, Typography, Grid } from '@mui/material';
import StyledModal from '../StyledModal';
import { TextField } from '../../common';
import { incomeParameters } from '../../../utils/api';

export default function MassEditPlantParametersModal(props) {
  const { handleChange, values } = useForm({
    value1: 0,
    value2: 0,
    value3: 0,
  });

  const handleClose = () => props.setOpen(false);

  const editParameters = () => {
    if (props.local) {
      props.setData(
        props.data.map((el) => {
          return props.selected?.includes(el.id)
            ? {
                ...el,
                indexList: [
                  {
                    maxArea: el.indexList[0].maxArea,
                    minArea: el.indexList[0].minArea,
                    incomeValue: values.value1,
                  },
                  {
                    maxArea: el.indexList[1].maxArea,
                    minArea: el.indexList[1].minArea,
                    incomeValue: values.value2,
                  },
                  {
                    maxArea: el.indexList[2].maxArea,
                    minArea: el.indexList[2].minArea,
                    incomeValue: values.value3,
                  },
                ],
                edited: true,
              }
            : el;
        })
      );
      handleClose();
    } else {
      const body = {
        idList: props.selected,
        indexList: [
          {
            incomeValue: values.value1,
          },
          {
            incomeValue: values.value2,
          },
          {
            incomeValue: values.value3,
          },
        ],
      };
      incomeParameters
        .editCropGroupParameters(body)
        .then((res) => {
          props.updateParameters();
          handleClose();
        })
        .catch((err) => {});
    }
  };

  return (
    <>
      <StyledModal open={props.open} handleClose={handleClose}>
        <Box>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ mb: 2 }}
          >
            <Typography sx={{ fontSize: 36, fontWeight: 500 }}>
              Edytuj masowo zaznaczone wskaźniki
            </Typography>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="center"
            sx={{ mt: 3 }}
          >
            <TextField
              label="Wartość PLN - Przedział 1"
              modalRight
              type="number"
              variant="outlined"
              value={values.value1}
              onChange={handleChange('value1')}
            />
          </Grid>
          <Grid container direction="row" justifyContent="center">
            <TextField
              label="Wartość PLN - Przedział 2"
              modalRight
              type="number"
              variant="outlined"
              value={values.value2}
              onChange={handleChange('value2')}
            />
          </Grid>
          <Grid container direction="row" justifyContent="center">
            <TextField
              label="Wartość PLN - Przedział 3"
              modalRight
              type="number"
              variant="outlined"
              value={values.value3}
              onChange={handleChange('value3')}
            />
          </Grid>
          <Grid
            container
            justifyContent="space-evenly"
            sx={{ mt: 2 }}
            columnSpacing={1}
          >
            <Grid item xs={4}>
              <Button variant="outlined" onClick={editParameters}>
                ZAPISZ
              </Button>
            </Grid>
          </Grid>
        </Box>
      </StyledModal>
    </>
  );
}
